import React from 'react';
import { useParams } from 'react-router-dom';
import { graphql, useLazyLoadQuery } from 'react-relay/hooks';
import AssignmentTypeTablePanel from '../panels/AssignmentTypeTablePanel';
export const CompanyAssignmentTypesPage = () => {
    const { companyId } = useParams();
    const data = useLazyLoadQuery(graphql `
      query CompanyAssignmentTypesPageQuery($companyId: ID!, $assignmentTypeFilter: AssignmentTypeFilterInput) {
        admin_company(id: $companyId) {
          name
        }
        ...AssignmentTypeTablePanel_query @arguments(where: $assignmentTypeFilter)
      }
    `, {
        companyId,
        assignmentTypeFilter: { companyId: { eq: companyId } },
    });
    return <AssignmentTypeTablePanel queryRef={data}/>;
};
export default CompanyAssignmentTypesPage;
